export default "__VITE_PUBLIC_ASSET__62233d32__"